import type { ReactNode } from "react"

import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { MinimalMarketingLayout } from "@/components/marketing/MinimalMarketingLayout"
import { isLaunchMode } from "@/lib/launch-config"

/** Shared pieces of the two `marketing_join_waitlist` forms: /request-access and /waitlist. */

export function joinWaitlistErrorMessage(error: unknown): string {
  const message = error instanceof Error ? error.message : String(error)
  if (message.includes("email_invalid")) return "Enter a valid email address."
  if (message.includes("email_required")) return "Email is required."
  return "Something went wrong. Please try again."
}

export const fieldClassName =
  "w-full min-w-0 rounded-lg bg-white px-4 py-3 text-base/6 text-mauve-950 inset-ring-1 inset-ring-black/10 placeholder:text-mauve-500 focus:inset-ring-2 focus:inset-ring-mauve-950/30 focus:outline-hidden dark:bg-white/10 dark:text-white dark:inset-ring-white/10 dark:placeholder:text-mauve-500"

export function Field({
  label,
  optional,
  children,
}: {
  label: string
  optional?: boolean
  children: ReactNode
}) {
  return (
    <label className="flex flex-col gap-2">
      <span className="text-sm/6 font-medium text-mauve-950 dark:text-white">
        {label}
        {optional ? <span className="ml-1 font-normal text-mauve-500">(optional)</span> : null}
      </span>
      {children}
    </label>
  )
}

export function useAccessFormLayout() {
  return isLaunchMode() ? MinimalMarketingLayout : MarketingLayout
}
